import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { AdItemBannerComponent } from './ad-item-banner.component';

@NgModule({
	declarations: [AdItemBannerComponent],
	imports: [SharedModule],
	exports: [AdItemBannerComponent],
})
export class AdItemBannerModule {}
